export const slotTypeOptions = {
  static: 'slot_attempt_static',
  question: 'slot_attempt_question',
  survey: 'slot_attempt_survey'
};
